export default {
  "contact.title": "Contactez-nous",
  "contact.subtitle": "Nous sommes à votre écoute. N'hésitez pas à nous contacter pour toute question.",
  "contact.info": "Informations",
  "contact.address": "Bonanjo, Douala, Cameroun",
  "contact.phone1": "+237 687 69 69 69",
  "contact.phone2": "+237 675 98 76 54",
  "contact.email": "contact@tennisclubdouala.com",
  "contact.hours": "Tous les jours, 8h – 22h",
  "contact.social": "Réseaux Sociaux",
  "contact.form.title": "Envoyez-nous un message",
  "contact.form.name": "Nom complet",
  "contact.form.email": "Email",
  "contact.form.phone": "Téléphone",
  "contact.form.subject": "Objet",
  "contact.form.message": "Message",
  "contact.form.cta": "Envoyer le message",
  "contact.form.success": "Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.",
  "contact.form.error": "Une erreur est survenue. Veuillez réessayer.",
  "contact.map": "Nous trouver"
}